<template>
  <div :class="{ 'required': selfContent.required, 'editable': !selfContent.readOnly }" style="width: calc(100% - 8px)">
    <label v-if="selfContent.label">{{ selfContent.label }}</label>
    <input
        style="display: none"
        ref="file"
        type="file"
        class="input"
        :accept="selfContent.accept ? selfContent.accept : '*'"
        @change="handleFileChange"
        :disabled="selfContent.readOnly"
    />
    <CustomButton @click="this.$refs.file.click()" :params=buttons.upload></CustomButton>
  </div>
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";

export default {
  name: 'CustomFileField',
  components: {CustomButton},
  props: ['content'],
  data() {
    return {
      selfContent: this.content,
      buttons: {
        upload : { text : "Téléverser" }
      }
    };
  },
  watch: {
    'selfContent.value'(val){
      if (val) {
        this.buttons.upload.text = this.selfContent.textUpload;
      } else {
        this.buttons.upload.text = this.selfContent.textNotUpload;
      }
    }
  },
  methods: {
    handleFileChange(event) {
      this.selfContent.value = event.target.files[0];
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.file-name
  margin-top: 5px
  font-size: 0.9em
  color: #666

div label
  display block
  margin 8px 0 4px 2px
  color CTRL_TEXT_MUTED
  font-size 0.82em
  font-weight 600

.icon
  top 30px
  color THEME_COLOR_SECONDARY

.input
  width 100%
  background-color THEME_COLOR_FOREGROUND
  outline none
  height 20px
  border-radius 3px
  border 1px solid #D1D1D4
  padding-top 5px
  padding-bottom 5px
  font-weight 700
  text-indent 10px
  color #a8a8a8
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

.input::placeholder
  color rgba(0, 51, 255, 0.33)

.editable
  label
    color CTRL_LABEL
  input:hover
    border-bottom 2px solid #1595d4
  input:focus
    border 2px solid #1595d4
  input
    border-bottom 2px solid #D1D1D4
    color FONT_COLOR

.bad_input
  border 2px solid #cd384e !important

.required label::after
  content " *"
  color CTRL_ERROR
</style>
